export default "__VITE_ASSET__rtxGS4WF__"